














import { Component, Prop, mixins } from 'nuxt-property-decorator';
import globalStyling from '~/mixins/globalStyling'
import LotUtilsMixin from '~/mixins/LotUtilsMixin'

@Component({
  mixins: [globalStyling, LotUtilsMixin],
})

export default class PlanDetailRange extends mixins(
    globalStyling,
    LotUtilsMixin
) {
    @Prop({default: 'Missing'}) title: string
    @Prop({default: 3}) min: number
    @Prop({default: null}) max: number
}
